// extracted by mini-css-extract-plugin
export default {"menu":"MenuLayout--menu--a844b3","contentWrapper":"MenuLayout--contentWrapper--d6917f","content":"MenuLayout--content--c35d98"};